export default __webpack_public_path__ + "7572317aa770b66a73b2da65692b53e0.svg";